import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../';
import { getRefreshToken } from '../../../utils/jwt';

const AuthRoute = ({ children }: { children: JSX.Element }) => {
    const { loading } = useContext(AuthContext)!;
    const location = useLocation();

    if (loading) {
        return <></>;
    }

    const refreshToken = getRefreshToken();

    if (!refreshToken) {
        const target = `${location.pathname}${location.search}${location.hash}`;
        sessionStorage.setItem("postLoginRedirect", target);
        return <Navigate to="/login" />;
    }

    return children;
};

export default AuthRoute;   